/* JerseyBird 2026 — site header (sections/jerseybird-2026-header.liquid) and homepage panels
   (sections/jerseybird-homepage-panels.liquid).
   Menu drawer with single-open accordions (both), mobile snap-carousel paint (grayscale + caption
   fade tied to scroll) and dot pagination (panels). Re-initialises on theme-editor section loads. */
(function () {
  'use strict';

  function clamp01(n) { return Math.max(0, Math.min(1, n)); }
  function toArray(list) { return Array.prototype.slice.call(list || []); }

  function initHome(root) {
    if (!root || root.dataset.jbInit) return;
    root.dataset.jbInit = '1';

    var mono = root.dataset.monochrome === 'true';
    var startIndex = parseInt(root.dataset.startIndex, 10) || 0;
    var rail = root.querySelector('.jb-rail');
    var slides = rail ? toArray(rail.children) : [];
    var dots = toArray(root.querySelectorAll('.jb-dots button'));

    /* ---------- mobile carousel ---------- */
    function slideOffset(i) { return slides[i].offsetLeft - slides[0].offsetLeft; }

    function paint() {
      if (!slides.length) return;
      var center = rail.scrollLeft + rail.clientWidth / 2;
      var best = 0;
      var bestD = Infinity;
      slides.forEach(function (slide, i) {
        var d = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
        if (d < bestD) { bestD = d; best = i; }
        if (mono) {
          var grey = 'grayscale(' + clamp01(d / (slide.offsetWidth * 0.7)).toFixed(3) + ')';
          toArray(slide.querySelectorAll('.jb-img')).forEach(function (img) { img.style.filter = grey; });
        }
        var mid = slide.querySelector('.jb-mid');
        if (mid) {
          var tc = clamp01(d / (slide.offsetWidth * 0.55));
          mid.style.opacity = (1 - tc * 0.95).toFixed(3);
          mid.style.transform = 'translateY(' + (tc * 28).toFixed(1) + 'px)';
        }
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('on', i === best);
        dot.setAttribute('aria-current', i === best ? 'true' : 'false');
      });
    }

    function goTo(i, smooth) {
      if (!slides[i]) return;
      if (smooth && typeof rail.scrollTo === 'function') {
        rail.scrollTo({ left: slideOffset(i), behavior: 'smooth' });
      } else {
        rail.scrollLeft = slideOffset(i);
      }
    }

    if (slides.length) {
      var tick = null;
      rail.addEventListener('scroll', function () {
        if (tick) return;
        tick = requestAnimationFrame(function () { tick = null; paint(); });
      }, { passive: true });
      window.addEventListener('resize', paint);
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i, true); });
      });
      requestAnimationFrame(function () {
        goTo(Math.min(startIndex, slides.length - 1), false);
        paint();
      });
    }

    /* ---------- menu drawer ---------- */
    var menu = root.querySelector('.jb-menu');
    var backdrop = root.querySelector('.jb-backdrop');
    var openBtn = root.querySelector('.jb-menu-btn');
    var closeBtn = root.querySelector('.jb-menu-close');
    var rows = toArray(root.querySelectorAll('.jb-row'));

    function closeRows() {
      rows.forEach(function (row) {
        row.classList.remove('open');
        var head = row.querySelector('.jb-row-h');
        if (head) head.setAttribute('aria-expanded', 'false');
      });
    }

    function setMenu(open) {
      if (!menu) return;
      root.classList.toggle('jb-menu-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        if (closeBtn) closeBtn.focus();
      } else {
        closeRows();
        if (openBtn) openBtn.focus();
      }
    }

    if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
    if (backdrop) backdrop.addEventListener('click', function () { setMenu(false); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('jb-menu-open')) setMenu(false);
    });

    rows.forEach(function (row) {
      var head = row.querySelector('button.jb-row-h');
      if (!head) return;
      head.addEventListener('click', function () {
        var wasOpen = row.classList.contains('open');
        closeRows();
        if (!wasOpen) {
          row.classList.add('open');
          head.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* exposed for theme-editor block selection */
    root.jbGoTo = goTo;

    initSlideshows(root);
  }

  /* ---------- panel slideshows ----------
     A panel with extra .jb-img--slide photos crossfades through them in order, then back to its
     base photo, continuously. Slides stack in DOM order; "is-on" is set on every slide up to the
     current one so each fade is the next photo appearing over the previous. Pauses in hidden tabs
     and stays on the base photo when the visitor prefers reduced motion. */
  function initSlideshows(root) {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    toArray(root.querySelectorAll('[data-jb-slideshow]')).forEach(function (panel) {
      if (panel.dataset.jbSlidesInit) return;
      var slides = toArray(panel.querySelectorAll('.jb-img--slide'));
      if (!slides.length || reduceMotion) return;
      panel.dataset.jbSlidesInit = '1';
      var interval = Math.max(1500, parseInt(panel.dataset.interval, 10) || 4000);
      var current = 0; /* 0 = base photo, 1..n = slides */
      var timer = null;
      function step() {
        current = (current + 1) % (slides.length + 1);
        slides.forEach(function (img, k) { img.classList.toggle('is-on', k < current); });
      }
      function start() { if (!timer) timer = setInterval(step, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
      start();
    });
  }

  /* The theme's cart drawer used to be started by the Impulse header section; the JB 2026 header
     renders the drawer markup, so start it here once theme.js (loaded earlier, also deferred) is in. */
  function initCartDrawer() {
    var form = document.getElementById('CartDrawerForm');
    if (!form || form.dataset.jbInit) return;
    if (!window.theme || typeof theme.CartDrawer !== 'function') return;
    if (!theme.settings || theme.settings.cartType !== 'drawer') return;
    if (document.body.classList.contains('template-cart')) return;
    form.dataset.jbInit = '1';
    new theme.CartDrawer();
  }

  function initAll(scope) {
    toArray((scope || document).querySelectorAll('[data-jb-home], [data-jb-header]')).forEach(initHome);
    initCartDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor hooks */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  function setActivePanel(sectionEl, blockId) {
    var root = sectionEl.querySelector('[data-jb-home]');
    if (!root) return;
    var index = -1;
    toArray(root.querySelectorAll('.jb-hero-d .jb-panel')).forEach(function (panel, i) {
      var active = !!blockId && panel.dataset.blockId === blockId;
      panel.classList.toggle('jb-panel--active', active);
      if (active) index = i;
    });
    if (index > -1 && typeof root.jbGoTo === 'function') root.jbGoTo(index, true);
  }
  /* Nested sub-link groups (snippets/jb-sublinks.liquid): the chevron shows or hides the children.
     Delegated so it covers the desktop panels, the mobile slides and the menu drawer alike.
     This file is included by both the header and the panels section, so guard against
     registering the listener twice (two listeners would open then immediately close). */
  if (!document.documentElement.dataset.jbGroupToggle) {
    document.documentElement.dataset.jbGroupToggle = '1';
    document.addEventListener('click', onGroupToggle);
  }
  function onGroupToggle(e) {
    var toggle = e.target.closest ? e.target.closest('.jb-group__toggle') : null;
    if (!toggle) return;
    e.preventDefault();
    e.stopPropagation();
    var group = toggle.closest('.jb-group');
    var sub = group && group.querySelector('.jb-sub');
    if (!sub) return;
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    sub.hidden = open;
    group.classList.toggle('jb-group--open', !open);
  }

  document.addEventListener('shopify:block:select', function (e) {
    if (e.detail && e.detail.blockId) setActivePanel(e.target, e.detail.blockId);
  });
  document.addEventListener('shopify:block:deselect', function (e) { setActivePanel(e.target, null); });
})();
